import { FooterSettingApi } from '../footer-settings/api/footer-settings-api';
import { HeaderBannerApi } from '../header-banner/api/header-banner-api';
import { NewsPostApi } from '../news-post/api/news-post-api';
import { SponsorBannerApi } from '../sponsor-banner/api/sponsor-banner-api';
import { StaticSitesApi } from '../static-sites/api/static-sites-api';
import { SupplierSpecialOffersApi } from '../supplier-special-offers/api/supplier-special-offers-api';

export class ContentManagementApi {
    constructor(protected baseUrl: string) {
        this.HeaderBanner = new HeaderBannerApi(this.baseUrl);
        this.NewsPost = new NewsPostApi(this.baseUrl);
        this.StaticSites = new StaticSitesApi(this.baseUrl);
        this.SupplierSpecialOffers = new SupplierSpecialOffersApi(this.baseUrl);
        this.SponsorBanner = new SponsorBannerApi(this.baseUrl);
        this.FooterSetting = new FooterSettingApi(this.baseUrl);
    }

    public HeaderBanner: HeaderBannerApi;
    public NewsPost: NewsPostApi;
    public StaticSites: StaticSitesApi;
    public SupplierSpecialOffers: SupplierSpecialOffersApi;
    public SponsorBanner: SponsorBannerApi;
    public FooterSetting: FooterSettingApi;
}
